import { useQuery } from 'react-query';
import { errorToast } from 'lib/components/toasts/error';
import { EXPRESS_API } from 'configs/api/expressApi';
import { PaginationConstants } from 'lib/const/PaginationConstants';
import { organizationVideoQueryKeys } from './queryKeys';

export interface OrganizationVideo {
  organizationVideoId: number;
  organizationId: number;
  title: string;
  fileName: string;
  year: number;
  make: string;
  model: string;
  description: string;
  videoUrl: string;
  thumbnailUrl: string;
  library: string;
  playlist: string;
}

export enum OrganizationVideoSortKey {
  CREATED_AT = 'createdAt',
  YEAR = 'year',
  MAKE = 'make',
  MODEL = 'model',
  PLAYLIST = 'playlist',
  LIBRARY = 'library',
  TITLE = 'title',
}

type Params = {
  limit: number;
  page: number;
  search?: string;
  filter?: { [key: string]: string[] };
  sortKey?: OrganizationVideoSortKey;
  order?: PaginationConstants;
};

const getOrgVideos = async (
  props: Params
): Promise<{ videos: OrganizationVideo[]; count: number }> => {
  const params = {
    limit: props.limit,
    search: props.search,
    page: props.page + 1,
    filter: props.filter,
    sortKey: props.sortKey,
    order: props.order,
  };

  const response = await EXPRESS_API.get(`/organization-videos`, {
    params,
  });
  return response.data as { videos: OrganizationVideo[]; count: number };
};

export const useOrganizationVideosQuery = (
  params: Params,
  enabled: boolean = true,
  handleModalClose?: () => void
) => {
  return useQuery(
    organizationVideoQueryKeys.list({
      page: params.page,
      search: params.search || '',
      filter: params.filter,
      sortKey: params.sortKey as string,
      order: params.order as string,
    }),
    () => getOrgVideos(params),
    {
      refetchOnMount: true,
      onError: () => {
        errorToast({
          title: "We're currently experiencing difficulties fetching videos",
        });
        handleModalClose?.();
      },
      enabled,
    }
  );
};
